import React, { useContext } from "react";
import { CategoryItem } from "../../helpers/customerService";
import SectionWrapper from "./SectionPage/components/Section/SectionWrapper";
import { Typography } from "@mui/material";
import { BNBox, BNButton, BNStack, Faq } from "@bn-monorepo/js-packages";
import { SettingsContext } from "../../settingsContext";
import { Link } from "react-router";

interface Props {
  name: string;
  categoryList: CategoryItem[];
  enableAccordianFaq: boolean;
}

const AllQuestions: React.FC<Props> = ({ name, categoryList, enableAccordianFaq }) => {
  const settings = useContext(SettingsContext);
  return (
    <>
      <SectionWrapper noImage anchorId="" backgroundColor={"transparent"}>
        <Typography component={"h1"} variant="h4">
          {name}
        </Typography>
        <BNBox>
          {categoryList.map((category) => (
            <BNBox
              key={"category" + category.id}
              sx={{
                py: 2,
              }}
            >
              <Typography
                component={"h2"}
                variant="h4"
                sx={{
                  fontWeight: "bold",
                }}
              >
                {category.name}
              </Typography>
              <BNStack
                sx={{
                  mt: 2,
                  display: "grid",

                  gridTemplateColumns: {
                    xs: "repeat(1, minmax(20rem, 1fr))",
                    sm: "repeat(2, minmax(20rem, 1fr))",
                    md: "repeat(3, minmax(20rem, 1fr))",
                  },

                  gap: 4,
                }}
              >
                {category.secondCategoryList &&
                  category.secondCategoryList.map((subcategory) => (
                    <BNBox key={"subcategory" + subcategory.id}>
                      <Typography
                        component={"h3"}
                        variant="h6"
                        sx={{
                          fontWeight: "bold",
                          mb: 2,
                        }}
                      >
                        {subcategory.name}
                      </Typography>
                      {enableAccordianFaq ? (
                        <Faq
                          list={subcategory.qaList.map((qa) => ({
                            question: qa.question,
                            answer: qa.answer,
                          }))}
                        />
                      ) : (
                        <BNStack
                          sx={{
                            alignItems: "start",
                          }}
                        >
                          {subcategory.qaList &&
                            subcategory.qaList.map((qa) => (
                              <BNButton
                                id={qa.question}
                                key={"question" + qa.id}
                                to={settings.resolveUrl(qa.url)}
                                component={Link}
                                variant="text"
                                sx={{ px: 0 }}
                              >
                                {qa.question}
                              </BNButton>
                            ))}
                        </BNStack>
                      )}
                    </BNBox>
                  ))}
              </BNStack>
            </BNBox>
          ))}
        </BNBox>
      </SectionWrapper>
    </>
  );
};

export default AllQuestions;
